<template>
  <section
    :class="{
      pagec: true,
      'animated-section start-page': true,
      'section-active': ready,
      'animated-scrollbar': true
    }"
    style="background-color: white"
  >
    <div class="section-content vcentered">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div
            class="title-block"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="my-gif" src="/img/aac-gif.gif" alt="" />
            <h2 class="my-name" style="color: #666; margin-top: 20px">{{ data.fullname }}</h2>
            <div class="owl-carousel text-rotation">
              <div class="item" v-for="(item, i) in data.jobs" :key="i">
                <div class="sp-subtitle" style="color: #666">{{ item }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { onMounted, ref, onBeforeUnmount, inject } from 'vue'

export default {
  setup() {
    const data = inject('data')
    const ready = ref(false)
    onMounted(() => {
      ready.value = true
      $('.text-rotation').owlCarousel({
        loop: true,
        dots: false,
        nav: false,
        margin: 0,
        items: 1,
        autoplay: true,
        autoplayHoverPause: false,
        autoplayTimeout: 3800,
        animateOut: 'animated-section-scaleDown',
        animateIn: 'animated-section-scaleUp'
      })
    })

    onBeforeUnmount(() => {
      ready.value = false
    })

    return { ready, data }
  }
}
</script>
<style scoped>
.my-name {
  font-size: 35px;
  line-height: 40px;
}

.my-gif {
  width: 400px;
}

@media (min-width: 992px) {
  .my-name {
    font-size: 45px;
    line-height: normal;
  }

  .my-gif {
    width: 350px;
  }
}
</style>
